import React from "react";

function BulkUploadUserManual() {
  const columns = [
    { key: "columnName", label: "Column Name" },
    { key: "description", label: "Description" },
    { key: "fieldType", label: "Field Type" },
    { key: "expectedValue", label: "Expected Value" },
    { key: "mandatory", label: "Mandatory" }
  ];
  const rows = [
    {
      columnName: "Machine Name",
      description: "Name of the machine",
      expectedValue: "Abcd",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Model Machine Size",
      description: "Model size of the machine",
      expectedValue: "Large",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Machine Number",
      description: "Unique identifier of the machine",
      expectedValue: "1000A21",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Tank Size (L)",
      description: "Capacity of the machine tank in liters",
      expectedValue: "1000",
      fieldType: "Numeric",
      mandatory: true
    },
    {
      columnName: "Lower Conc Parameter (%)",
      description: "Minimum allowed concentration percentage",
      expectedValue: "5",
      fieldType: "Numeric",
      mandatory: true
    },
    {
      columnName: "Higher Conc Parameter (%)",
      description: "Maximum allowed concentration percentage",
      expectedValue: "10",
      fieldType: "Numeric",
      mandatory: true
    },
    {
      columnName: "Percent Oil Topup",
      description: "Percentage of oil added as a top-up",
      expectedValue: "5",
      fieldType: "Numeric",
      mandatory: true
    },
    {
      columnName: "Water Used",
      description: "Amount of water used",
      expectedValue: "10",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Company",
      description: "Name of the company",
      expectedValue: "abcd",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Coolant Oil",
      description: "Name of the coolant oil (Brandname-Productname format)",
      expectedValue: "XYZ-CoolantX",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Hydraulic Oil",
      description: "Name of the hydraulic oil (Brandname-Productname format)",
      expectedValue: "ABC-HydroMax",
      fieldType: "Text",
      mandatory: true
    },
    {
      columnName: "Maintenance Oil",
      description: "Name of the maintenance oil (Brandname-Productname format)",
      expectedValue: "PQR-MaintainPro",
      fieldType: "Text",
      mandatory: true
    }
  ];
    
    return(
       <div className="table-container d-flex flex-column" style={{gap:"1rem"}}>
        <h4 className="">Demo Machine Item Exmaple</h4>
        <table className="w-100">
           <thead>
            <tr className="table-head">
              {columns.map((col)=>(
                <th key={col.key} className="px-3 py-2 text-xs">
                   {col.label}
                </th>
              ))}
            </tr>
           </thead>
           <tbody>
           {rows.map((row, index) => (
            <tr key={index} className="border-b">
              {columns.map((col) => (
                <td key={col.key} className="px-3 py-2 ">
                  {col.key === "mandatory" ? (
                    row[col.key] ? "✅" : "❌"
                  ) : (
                    row[col.key]
                  )}
                </td>
              ))}
            </tr>
          ))}
           </tbody>
        </table>
        <div className="important-note p-2">
          <p style={{ fontSize: "14px", fontWeight: "500", textWrap:"pretty", margin:"0px"}}>
                  <strong style={{ color: "red" }}>Note:</strong> The Oils (Coolant
                  Oil/Hydraulic Oil/Maintenance Oil) must follow the format{" "}
                  <code>Brandname-Productname</code> with a hyphen <code>-</code>{" "}
                  separating the brand and product names.
                </p>
        </div>
       </div>
    )
}

export default BulkUploadUserManual;
